import React from 'react';

export const STUDIO_PAGE_NUMBER_RIGHT = 27;
export const STUDIO_PAGE_NUMBER_RIGHT_STORY = 30;

interface StudioPageNumberProps {
  pageNumber?: number;
  pageCount?: number;
  color: string;
  isStory?: boolean;
}

const StudioPageNumber: React.FC<StudioPageNumberProps> = ({
  pageNumber = 1,
  pageCount = 7,
  color,
  isStory = false
}) => {
  const formatNumber = (value: number) => String(value).padStart(2, '0');
  const current = formatNumber(pageNumber);
  const total = formatNumber(pageCount);
  const label = `${current} / ${total}`;

  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        zIndex: 3,
        top: isStory ? 26 : 20,
        right: isStory ? STUDIO_PAGE_NUMBER_RIGHT_STORY : STUDIO_PAGE_NUMBER_RIGHT,
        color,
        fontSize: isStory ? 10 : 8.5,
        fontWeight: 800,
        letterSpacing: 1.6,
        lineHeight: 1,
        textTransform: 'uppercase',
        pointerEvents: 'none',
        userSelect: 'none'
      }}
    >
      {label}
    </div>
  );
};

export default StudioPageNumber;
